export class DefaultRefinements {
  // Ids
  public idUniverse: Set<number> = new Set();
  public idBrand: Set<number> = new Set();
  public idMaterials: Set<number> = new Set();
  public idPattern: Set<number> = new Set();
  public idColors: Set<number> = new Set();
  public idCondition: Set<number> = new Set();
  public idCategory: Set<number> = new Set();
  public idSubcategory: Set<number> = new Set();
  public idModel: Set<number> = new Set();
  public idSize: Set<number> = new Set();
  public idWatchMechanism: Set<number> = new Set();
  public discount: Set<number> = new Set();
  public searchQuery: Set<string> = new Set();
  public path = '';
  public priceMin: Set<number> = new Set();
  public priceMax: Set<number> = new Set();
  public tags: Set<string> = new Set();

  /**
   * Format the instance of DefaultRefinements in order
   * to transform usage of sets to array
   * @memberof DefaultRefinements
   */
  public formatSetsToArray() {
    let transformedRefinements = {};
    for (const key in this) {
      if (!this.hasOwnProperty(key)) {
        continue;
      }
      if (this[key] instanceof Set) {
        transformedRefinements = {
          ...transformedRefinements,
          [`${key}`]: Array.from(this[`${key}`])
        };
        continue;
      }
      transformedRefinements[`${key}`] = this[key];
    }

    return transformedRefinements;
  }
}
